import React, { useEffect, useRef, useState } from "react";

import useIntersectionObserver from "./useIntersectionObserver";
import useVisibilityOnScroll from './useVisibilityOnScroll'; 
import "./animation1.scss";
import Spanizer from './Spanizer';

const divsToUpdate = document.querySelectorAll(".boilerplate-update-me-animation1")

divsToUpdate.forEach(div => {
  const data = JSON.parse(div.querySelector("pre").innerText)
  ReactDOM.render(<OurComponent {...data} />, div)
  div.classList.remove("boilerplate-update-me-animation1")
})

function OurComponent() {


  
    return (
      <main>
        <section className="mast">
          <figure className="mast__bg"></figure>
          <header className="mast__header">
            <h1 className="mast__title">
              <Spanizer text="Incoming Transmission" />
            </h1> 
            <hr className="sep" />
            <p className="mast__text" >
              <Spanizer text="This is a story, all about how, My life got twisted upside down. 
              So I'd like to tell a story, just sit right there. 
              And I'll tell you how I became the prince of Bel Air. sdfs dfsdf skldfj ölskdj asöldfkn l öjfölkjsföljsf lksajflöskfj lkjsf öls jfsldkjf ölkjss" />
            </p>

            <p className="mast__text">
              <Spanizer text="This is a story, all about how, My life got twisted upside down. 
              So I'd like to tell a story, just sit right there. 
              And I'll tell you how I became the prince of Bel Air." />
            </p>
          </header>
        </section>
      </main>
    );
  };
  


